export default "__VITE_ASSET__Cl$thwZ5__"